module.exports = __webpack_public_path__ + "img/diapositiva-10-3.8e72a37f.jpg";